module.exports = __webpack_public_path__ + "static/media/yellow-boxfish.cf10a83f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/yellow-boxfish.png
// module id = 340
// module chunks = 0